import React from "react";
import Table from "../../table/table";
import OrganizationMembersListRow from "./organizationMemberListRow/organizationMembersListRow";
import FaSpinner from "@/components/faSpinner/faSpinner";

const TABLE_HEADER = [
  {
    title: "MEMBER NAME",
  },
  {
    title: "STATUS",
  },
  {
    title: "ROLE",
  },
  {
    title: "OPERATIONS",
  },
];

const OrganizationMembersList = (props) => {
  const { organizationUuid, memberOperations, members } = props;
  if (members.length === 0)
    return (
      <div>
        <FaSpinner loading={true} />
      </div>
    );
  return (
    <Table
      className="nbg_table"
      cellsNumber={4}
      header={TABLE_HEADER}
      rows={members}
      rowProps={{
        ...memberOperations,
        organizationUuid,
      }}
      RenderRow={OrganizationMembersListRow}
    />
  );
};

export default OrganizationMembersList;
